module.exports = __webpack_public_path__ + "img/title-bg.0defadf0.png";